export default "__VITE_ASSET__$IpHq2nM__"